import { render, staticRenderFns } from "./ourselves.vue?vue&type=template&id=1f461a1c&scoped=true&"
import script from "./ourselves.vue?vue&type=script&lang=js&"
export * from "./ourselves.vue?vue&type=script&lang=js&"
import style0 from "./ourselves.vue?vue&type=style&index=0&id=1f461a1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f461a1c",
  null
  
)

export default component.exports